import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getModel } from './selectors';
import GeneralFilterComponent from './GeneralFilterComponent';
import * as actions from './actions';
import { apiCallStatus } from 'helpers/constants';
import { clearStore } from '../../PowertrainAssetDetails/CrossAssetAnalysis/ChartView/actions';
import PropTypes from 'prop-types';

const GeneralFilterContainer = (props) => {
    const {
        selectedFilters: { organizations },
        loadingData: {
            organizationsLoadingStatus,
            sitesLoadingStatus,
            assetGroupsLoadingStatus
        },
        rawSites,
        isAdmin,
        isCIAMSyncFlag,
    } = props.model;

    useEffect(() => {
        if (organizationsLoadingStatus === apiCallStatus.SUCCESS
            && sitesLoadingStatus === apiCallStatus.SUCCESS
            && assetGroupsLoadingStatus === apiCallStatus.SUCCESS
            && organizations.length
            && Array.isArray(rawSites)) {
            let refreshFlag = true;
            if (isAdmin) {
                if (isCIAMSyncFlag) { refreshFlag = true; }
                else { refreshFlag = false; }
            }
            props?.actions?.launchCIAMSyncForAdmin(organizations, props?.model?.selectedFilters?.countries, refreshFlag);
            props?.actions?.setCIAMSyncFlag(false);
        }
    }, [sitesLoadingStatus, organizationsLoadingStatus, assetGroupsLoadingStatus, organizations]);


    return <GeneralFilterComponent {...props} />;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...actions, clearStore }, dispatch)
    };
};

GeneralFilterContainer.propTypes = {
    model: PropTypes.shape({
        selectedFilters: PropTypes.shape({
            organizations: PropTypes.array,
        }),
        loadingData: PropTypes.shape({
            organizationsLoadingStatus: PropTypes.string,
            sitesLoadingStatus: PropTypes.string,
            assetGroupsLoadingStatus: PropTypes.string,
        }),
        rawSites: PropTypes.array,
        isAdmin: PropTypes.bool,
        isCIAMSyncFlag: PropTypes.bool,
    }),
    actions: PropTypes.shape({
        launchCIAMSyncForAdmin: PropTypes.func,
        setCIAMSyncFlag: PropTypes.func,
    }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GeneralFilterContainer);
